import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartbeatLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/system/heartbeat_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.51436 3.0001C9.95701 3.00656 10.3428 3.3032 10.4627 3.72936L14.1359 16.7897L16.0637 11.649C16.21 11.2587 16.5832 11.0001 17 11.0001H20C20.5523 11.0001 21 11.4478 21 12.0001C21 12.5524 20.5523 13.0001 20 13.0001H17.693L14.9363 20.3512C14.7845 20.7561 14.3897 21.0175 13.9577 20.9992C13.5257 20.9809 13.1544 20.6871 13.0373 20.2708L9.44954 7.51419L7.95448 12.2984C7.82402 12.7159 7.43739 13.0001 7 13.0001H4C3.44772 13.0001 3 12.5524 3 12.0001C3 11.4478 3.44772 11.0001 4 11.0001H6.26481L8.54552 3.70183C8.67756 3.27928 9.07171 2.99385 9.51436 3.0001Z"
		})
	})
});
export default SvgHeartbeatLine;
